import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "@/lib/api";
import Header from "@/components/public/Header";
import Footer from "@/components/public/Footer";
import { useLanguage } from "@/context/LanguageContext";

export default function PublicLayout() {
  const { lang } = useLanguage();
  const [settings, setSettings] = useState(null);
  const location = useLocation();

  // Re-fetch settings whenever the language changes so header/footer update.
  useEffect(() => {
    api
      .get("/public/bundle", { params: { lang } })
      .then(({ data }) => setSettings(data.settings))
      .catch(() => {});
  }, [lang]);

  // Honor hash anchors after route/lang changes; otherwise scroll to top.
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      const attempt = (tries = 0) => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (tries < 10) {
          setTimeout(() => attempt(tries + 1), 80);
        }
      };
      attempt();
      return;
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname, location.hash, location.key]);

  return (
    <div className="public-root min-h-screen">
      <Header settings={settings} />
      <main className="bg-ivory">
        <Outlet context={{ settings }} />
      </main>
      <Footer settings={settings} />
    </div>
  );
}
